/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import { NotificationBellIcon, NotificationBellIconInActive } from '../common/icons/notificationBellIcon';
import { CurrentTrackPoint } from '../common/interfaces/types';
import { ActiveHurricaneWidgetIcon } from './activeHurricaneWidgetIcon';
import { HurricaneOutlookSummaryIconColours } from './constants';
import { HurricaneWidgetType } from './types';

interface HurricaneWidgetNotificationIconProps {
    hurricaneIconType?: typeof HurricaneWidgetType[keyof typeof HurricaneWidgetType];
    iconColor?: typeof HurricaneOutlookSummaryIconColours[keyof typeof HurricaneOutlookSummaryIconColours];
    currentTrackPoint?: CurrentTrackPoint;
}

export const HurricaneWidgetNotificationIcon = ({ 
    hurricaneIconType=HurricaneWidgetType.noActiveHurricaneOrWarning,
    currentTrackPoint, 
    iconColor }: HurricaneWidgetNotificationIconProps) => {

    if (hurricaneIconType === HurricaneWidgetType.activeHurricane && currentTrackPoint) {
        return <ActiveHurricaneWidgetIcon currentTrackPoint={currentTrackPoint} />;
    }

    if (hurricaneIconType === HurricaneWidgetType.hurricaneOutlook) {
        return <NotificationBellIcon backgroundFillColor={iconColor} />;
    }
    // default return Bell Icon UI
    // when there's no (active hurricane + hurricane outlook) data
    return <NotificationBellIconInActive />;
};

